<template id="mLogin">
    <div  class="div_login_m" v-if="showLogin" >
        <div class="parts_m">
            <div style="display: flex; justify-content: flex-end; width: 100%;" @click="setShowLogin(false)">
                <img src="/static/imgs/bt_close_c.png" class="im_close_m" onMouseOver="this.style.cursor='pointer'">
            </div>

            <div style="text-align: center;">
                <span class="tx_login3">{{ getInterText(inter_ind.entrar) }}</span>
            </div>

            <div class="div_nome_l">
                <span class="tx_nome_before" @click="clickInput(1, true)" v-if="!editing[1].status" onMouseOver="this.style.cursor='pointer'" tabindex="2">E-mail</span>
                <div class="hr" @click="clickInput(1, true)" onMouseOver="this.style.cursor='pointer'" v-if="!editing[1].status"/>
                <span class="tx_nome" @click="clickInput(1, false)" v-if="editing[1].status">E-mail</span>
                <input id="emailid" class="input_name_m" type="text" v-model="editing[1].texto" v-if="editing[1].status" tabindex="3"/>
                <span v-if="!checkEmail(editing[1].texto) && editing[1].texto.length>5" class="error_msg">{{ getInterText(inter_ind.email_invalido) }}</span>
            </div>

            <div class="div_nome_l">
                <span class="tx_nome_before" @click="clickInput(0, true)" v-if="!editing[0].status" onMouseOver="this.style.cursor='pointer'"> {{ getInterText(inter_ind.senha) }} </span>
                <div class="hr" @click="clickInput(0, true)" onMouseOver="this.style.cursor='pointer'" v-if="!editing[0].status"/>
                <span class="tx_nome" @click="clickInput(0, false)" v-if="editing[0].status"> {{ getInterText(inter_ind.senha) }} </span>
                <input id="nameid" class="input_name_m" type="password" v-model="editing[0].texto" v-if="editing[0].status" tabindex="4"/>
                <span v-if="!checkPass(editing[0].texto) && editing[0].texto!=''" class="error_msg">{{ getInterText(inter_ind.senha_errada) }}</span>
            </div>

            <span v-if="senhaErrada" class="error_msg">{{ getInterText(inter_ind.senha_errada_2) }}</span>

            <img v-if="loading.user" src="/static/imgs/loading5.gif" alt="Carregando" class="im_loading_up">

            <div class="div_botao_m" @click="tryLogin()" onMouseOver="this.style.cursor='pointer'" tabindex="4">
                <span class="tx_continuar_w"> {{ getInterText(inter_ind.continuar) }} </span>
            </div>
        </div>
    </div>
</template>

<script>
    import { advMixin } from '../scripts/advMixin'

    export default {
        name: 'mLogin',
        mixins: [advMixin],
        data () {
            return {
            }
        },
        methods: {

        },
        created() {
            console.log('created!!');

            console.log('Terminei o created!!');
        },
        beforeMount() {
            console.log('beforeMount!!');

            console.log('Terminei o beforeMount!!');
        },
        mounted() {
            console.log('mounted!!');

            console.log('Terminei o mounted!!');
        },

    }



</script>

<style src="../assets/css/adv.css" scoped/>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/mLogin.vue